import React from 'react';
import styled from 'styled-components';

const StyledMarker = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	transform: translate(-50%);
	position: relative;

	.text {
		white-space: pre;
		padding: 0.25rem 0.25rem 0.5rem;
		border-radius: 0.5rem;
		background-color: rgba(255, 255, 255, 0.9);
		display: none;
		text-align: center;
		position: absolute;
		bottom: 2.5rem;
		&.is-active {
			display: block;
		}
		&::after {
			content: '';
			position: absolute;
			left: 50%;
			bottom: -1rem;
			transform: translateX(-50%);
			width: 0;
			height: 0;
			display: block;
			border-left: 1rem solid transparent;
			border-right: 1rem solid transparent;
			border-top: 1rem solid rgba(255, 255, 255, 0.9);
		}
		h3 {
			font-size: 1.2rem;
			color: ${(p) => p.theme.color.dark};
		}
		a {
			color: ${(p) => p.theme.color.dark};
			&:hover {
				color: ${(p) => p.theme.color.red};
			}
			p {
				font-size: 0.9rem;
				line-height: 1.1rem;
			}
		}
	}
`;

export default ({
	name,
	link,
	address1,
	address2,
	index,
	toggleBaloon,
	showBaloon,
}) => {
	return (
		<StyledMarker
			className={showBaloon ? '' : 'not-active'}
			onClick={() => toggleBaloon(index)}
		>
			<div
				onClick={() => toggleBaloon(index)}
				className={showBaloon ? 'text is-active' : 'text'}
			>
				<h3>{name}</h3>
				<a target="_blank" rel="noopener noreferrer" href={link}>
					<p>{address1}</p>
					<p>{address2}</p>
				</a>
			</div>
			<img src="/img/logo.png" alt="arcadia logo" />
		</StyledMarker>
	);
};
